import React from 'react';
import { Link } from 'react-router-dom';
import DashboardSidebar from '../components/DashboardSidebar';

const AdminAnalyticsPage = () => {
  const stats = [
    { label: 'Total Visits', value: '12,450', change: '+15%' },
    { label: 'Active Users', value: '3,220', change: '+8%' },
    { label: 'Bookings', value: '1,840', change: '+22%' },
    { label: 'Revenue', value: '₹45,600', change: '+12%' }
  ];

  return (
    <>
      <DashboardSidebar userRole="admin" />
      <div style={{ minHeight: '100vh', background: '#f8f9fa', padding: '40px 20px', marginLeft: '280px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Link to="/admin-dashboard" style={{ color: '#667eea', textDecoration: 'none', marginBottom: '20px', display: 'inline-block' }}>
          ← Back to Dashboard
        </Link>
        <h1 style={{ fontSize: '32px', color: '#333', margin: '20px 0 10px 0' }}>📊 Analytics</h1>
        <p style={{ color: '#666', marginBottom: '30px' }}>Platform statistics and insights</p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '40px' }}>
          {stats.map((stat, idx) => (
            <div key={idx} style={{ background: 'white', borderRadius: '12px', padding: '25px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
              <p style={{ margin: '0 0 10px 0', color: '#666', fontSize: '14px' }}>{stat.label}</p>
              <h3 style={{ margin: '0 0 10px 0', fontSize: '28px', color: '#333' }}>{stat.value}</h3>
              <p style={{ margin: 0, color: '#10b981', fontSize: '14px', fontWeight: 600 }}>{stat.change} vs last month</p>
            </div>
          ))}
        </div>

        <div style={{ background: 'white', borderRadius: '12px', padding: '30px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
          <h2 style={{ margin: '0 0 20px 0', fontSize: '22px', color: '#333' }}>Monthly Trends</h2>
          <p style={{ color: '#999', textAlign: 'center', padding: '60px 20px', margin: 0 }}>📈 Analytics chart would appear here in a full implementation</p>
        </div>
      </div>
    </div>
    </>
  );
};

export default AdminAnalyticsPage;
